export enum AccessLevelTypes {
  DENY = 'deny',
  FULL_ACCESS = 'fullaccess',
  READ_ONLY = 'readonly'
}
